import React, { useState } from 'react'
import { Colors } from '../../common/Const';
import { images } from '../../common/Images';

function SearchCom(props) {
  const [windowSize, setWindowSize] = useState(window.innerWidth);
    const { display, setSearchVal, clearSearch, callSearchFilter, searchVal, onEnterFun, srchRef } = props;

  return windowSize >= 500 &&  
    <div style={{backgroundColor: 'white',width: '80%'}} className={"hd-srch-box d-flex justify-content-center align-items-center"}> 
    {/* cus-opt */}
      {/* <input type={"text"} placeholder="Search" /> */}
      {}
      <div class="input-group sec-input input_top">
        <div class="input-group-prepend d-flex justify-content-center align-items-center" style={{backgroundColor: 'rgb(133 147 24 / 14%)', borderRadius: '9px 0px 0 9px'}}>
        <span class="input-group-text" style={{backgroundColor: 'rgb(133 147 24 / 14%)', border:'none', outline: 'none', paddingRight: '5px'}} height="auto"  id="basic-addon1">
           <img
              src={images.Hsearch}
              width="20"
              height="20"
              alt="user"
              className="rounded-circle"
            />
           </span>
        </div>
        <input type="text" style={{backgroundColor: 'rgb(133 147 24 / 14%)'}} class="form-control border-0 search-input shadow-none" placeholder={"Search Here"} onChange={(e) => setSearchVal(e.target.value)} defaultValue={searchVal != "" && searchVal != 0 ? searchVal : ''} onKeyDown={onEnterFun} ref={srchRef} />
         <span role={"button"} style={{backgroundColor: 'rgb(133 147 24 / 14%)', color:Colors.Base_color}} className="d-flex align-items-center px-2" onClick={clearSearch} ><i class="fa-regular fa-circle-xmark"></i></span>
        <span role={"button"} style={{backgroundColor: Colors.Base_color, color: Colors.white_color}} className="d-flex align-items-center rounded-end px-2" onClick={callSearchFilter} >Search</span>
        {/* <span role={"button"} style={{backgroundColor: Colors.Base_color}} className="d-flex align-items-center rounded-end" onClick={callSearchFilter} ><i class="fa-solid fa-check px-3" style={{color: Colors.white_color}}></i></span> */}
      </div>
     </div> 
     
}

export default SearchCom